var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79381 0.0768217C8.46054 -0.0256074 8.1042 -0.0256071 7.77094 0.0768218L4.7852 0.994491C3.25085 1.46607 1.79367 2.15941 0.459883 3.05252C-0.387957 3.62023 0.0139223 4.94271 1.03428 4.94271H15.5305C16.5508 4.94271 16.9527 3.62023 16.1049 3.05252C14.7711 2.15941 13.3139 1.46607 11.7795 0.994491L8.79381 0.0768217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79381 0.0768217C8.46054 -0.0256074 8.1042 -0.0256071 7.77094 0.0768218L4.7852 0.994491C3.25085 1.46607 1.79367 2.15941 0.459883 3.05252C-0.387957 3.62023 0.0139223 4.94271 1.03428 4.94271H15.5305C16.5508 4.94271 16.9527 3.62023 16.1049 3.05252C14.7711 2.15941 13.3139 1.46607 11.7795 0.994491L8.79381 0.0768217Z",
    fill: "url(#paint0_linear_4_516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.532349 18.4427C0.532349 18.0285 0.868135 17.6927 1.28235 17.6927H15.2823C15.6966 17.6927 16.0323 18.0285 16.0323 18.4427C16.0323 18.8569 15.6966 19.1927 15.2823 19.1927H1.28235C0.868135 19.1927 0.532349 18.8569 0.532349 18.4427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.532349 18.4427C0.532349 18.0285 0.868135 17.6927 1.28235 17.6927H15.2823C15.6966 17.6927 16.0323 18.0285 16.0323 18.4427C16.0323 18.8569 15.6966 19.1927 15.2823 19.1927H1.28235C0.868135 19.1927 0.532349 18.8569 0.532349 18.4427Z",
    fill: "url(#paint1_linear_4_516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53235 14.4427C2.53235 14.8569 2.86813 15.1927 3.28235 15.1927C3.69656 15.1927 4.03235 14.8569 4.03235 14.4427L4.03235 8.44272C4.03235 8.0285 3.69656 7.69272 3.28235 7.69272C2.86813 7.69272 2.53235 8.02851 2.53235 8.44272L2.53235 14.4427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53235 14.4427C2.53235 14.8569 2.86813 15.1927 3.28235 15.1927C3.69656 15.1927 4.03235 14.8569 4.03235 14.4427L4.03235 8.44272C4.03235 8.0285 3.69656 7.69272 3.28235 7.69272C2.86813 7.69272 2.53235 8.02851 2.53235 8.44272L2.53235 14.4427Z",
    fill: "url(#paint2_linear_4_516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28235 15.1927C7.86813 15.1927 7.53235 14.8569 7.53235 14.4427L7.53235 8.44272C7.53235 8.02851 7.86813 7.69272 8.28235 7.69272C8.69656 7.69272 9.03235 8.0285 9.03235 8.44272V14.4427C9.03235 14.8569 8.69656 15.1927 8.28235 15.1927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28235 15.1927C7.86813 15.1927 7.53235 14.8569 7.53235 14.4427L7.53235 8.44272C7.53235 8.02851 7.86813 7.69272 8.28235 7.69272C8.69656 7.69272 9.03235 8.0285 9.03235 8.44272V14.4427C9.03235 14.8569 8.69656 15.1927 8.28235 15.1927Z",
    fill: "url(#paint3_linear_4_516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5323 14.4427C12.5323 14.8569 12.8681 15.1927 13.2823 15.1927C13.6966 15.1927 14.0323 14.8569 14.0323 14.4427V8.44272C14.0323 8.0285 13.6966 7.69272 13.2823 7.69272C12.8681 7.69272 12.5323 8.02851 12.5323 8.44272V14.4427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5323 14.4427C12.5323 14.8569 12.8681 15.1927 13.2823 15.1927C13.6966 15.1927 14.0323 14.8569 14.0323 14.4427V8.44272C14.0323 8.0285 13.6966 7.69272 13.2823 7.69272C12.8681 7.69272 12.5323 8.02851 12.5323 8.44272V14.4427Z",
    fill: "url(#paint4_linear_4_516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_516",
    x1: 8.26161,
    y1: 2.21851,
    x2: 8.26161,
    y2: 19.1927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_516",
    x1: 8.26161,
    y1: 2.21851,
    x2: 8.26161,
    y2: 19.1927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_516",
    x1: 8.26161,
    y1: 2.21851,
    x2: 8.26161,
    y2: 19.1927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_516",
    x1: 8.26161,
    y1: 2.21851,
    x2: 8.26161,
    y2: 19.1927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_516",
    x1: 8.26161,
    y1: 2.21851,
    x2: 8.26161,
    y2: 19.1927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/iconBank.567dafdb54926644afb69629d09f27d2.svg";
export { ForwardRef as ReactComponent };